const FL_VALUE = "FL";
const IP_VALUE = "IP";
const UL_VALUE = "UL";

const opf_types = [
  { name: "Физ. лицо", value: FL_VALUE },
  { name: "ИП", value: IP_VALUE },
  { name: "Юр. лицо", value: UL_VALUE },
];
export { opf_types, FL_VALUE, IP_VALUE, UL_VALUE };
